"use strict";

import angular from "angular";
import tableDreFakeTemplate from "./tables-fake/table-dre-fake.html";
import tableBalanceFakeTemplate from "./tables-fake/table-balance-fake.html";

angular.module("nucont.accounting.company.demonstrations").run([
    "$templateCache",
    ($templateCache) => {
        $templateCache.put("tableDreFake.html", tableDreFakeTemplate);
        $templateCache.put("tableBalanceFake.html", tableBalanceFakeTemplate);
    }
]);
